module.exports = __webpack_public_path__ + "static/media/7.afc744eb.svg";